import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Modal, Backdrop, Fade } from '@material-ui/core';
import Text from '../../../../components/Typography/Text';
import Button from '../../../../components/Buttons/Button';
import CloseButton from '../../../../components/Buttons/CloseButton';
import { ReactComponent as Info } from '../../../../assets/icons/info.svg';
import fontFamily from '../../../../assets/css/fonts';
import color from '../../../../assets/css/colors';
import { ReactComponent as Error } from '../../../../assets/icons/error.svg';
import { ReactComponent as Success } from '../../../../assets/icons/check-circle.svg';

const useStyles = makeStyles(() => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    maxWidth: 550,
    width: '100%',
    margin: '0 auto',
    float: 'clear',
  },
  modalHeader: {
    backgroundColor: 'white',
    padding: 25,
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10,
    display: 'flex',
    '& > div:nth-child(1)': {
      flex: 'none',
      marginRight: 7,
      '& > svg': {
        width: 28,
        height: 28,
        '& path': {
          fill: color.info.main,
        },
      },
    },
    '& div:nth-child(2)': {
      flex: 1,
    },
    '& div:nth-child(3)': {
      flex: 'none',
      '& .MuiIconButton-root': {
        borderRadius: 5,
        padding: 10,
        '&:hover svg path': {
          fill: color.primary.main,
        },
      },
      '& svg:last-child': {
        width: 15,
        height: 15,
      },
    },
  },
  modalBody: {
    backgroundColor: 'white',
    padding: '0px 25px 25px 25px',
    fontFamily: fontFamily.headers,
    '& p': {
      fontSize: 16,
      lineHeight: '24px',
    },
  },
  modalFooter: {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'flex-end',
    backgroundColor: 'white',
    padding: '0px 25px 25px 25px',
    borderBottomLeftRadius: 10,
    borderBottomRightRadius: 10,
    position: 'relative',
    '& button': {
      width: 120,
    },
  },
  incompleteSteps: {
    fontFamily: fontFamily.label,
    fontSize: 16,
    lineHeight: '24px',
    color: color.default.main,
    marginTop: 20,
    '& > label': {
      fontWeight: 600,
      marginBottom: 10,
      display: 'block',
    },
    '& ul': {
      listStyle: 'none',
      margin: '0px 0px 0px -40px',
      lineHeight: '30px',
      '& > li > span': {
        position: 'relative',
        top: 4,
        '& > svg': {
          width: 20,
          height: 20,
        },
      },
    },
  },
  success: {
    '& > svg > path': {
      fill: color.success.main,
    },
  },
  error: {
    '& > svg > path': {
      fill: color.error.main,
    },
  },
  closeButton: {
    '& button': {
      marginTop: '-5px !important',
    },
  },
}));

export default function StepsSubmitAttentionModal(props) {
  const classes = useStyles();

  const { open, onClose, forms, isBussinessAccount } = props;

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      className={classes.modal}
      open={open}
      onClose={onClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{ timeout: 500 }}
    >
      <Fade in={open}>
        <div>
          <div className={classes.modalHeader}>
            <div>
              <Info />
            </div>
            <div>
              <Text mt={4} variant="h2" label="Attention" />
            </div>
            <div className={classes.closeButton}>
              <CloseButton onClick={onClose} />
            </div>
          </div>
          <div className={classes.modalBody}>
            <Text
              variant="body1"
              label="Please remember that you can only submit your application
    once you completed all the necessary steps required. Thank you!"
            />
            <div className={classes.incompleteSteps}>
              <label>Completion Progress:</label>
              <div className="grd-row nm">
                <div className="grd-cell-none" style={{ marginRight: 30 }}>
                  <ul>
                    {forms.map((form, index) => {
                      if (
                        form.name === 'submit' ||
                        (isBussinessAccount && form.name === 'employment')
                      ) {
                        return <React.Fragment key={index}></React.Fragment>;
                      }
                      return (
                        <li key={index}>
                          <span
                            className={form.isCompleted ? classes.success : classes.error}
                          >
                            {form.isCompleted ? <Success /> : <Error />}
                          </span>{' '}
                          {form.label}
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className={classes.modalFooter}>
            <Button label="Okay" onClick={onClose} />
          </div>
        </div>
      </Fade>
    </Modal>
  );
}
